"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InMemoryAccountService = void 0;
const lodash_1 = __importDefault(require("lodash"));
const domain_1 = require("../../../domain");
class InMemoryAccountService {
    /* istanbul ignore next */
    getBalance(variables) {
        throw new Error("Method not implemented.");
    }
    sendUserEmailVerification(variables) {
        if (!lodash_1.default.isEmpty(variables === null || variables === void 0 ? void 0 : variables.token))
            return Promise.resolve();
        return Promise.reject(new domain_1.AccountServiceErrors.SendUserEmailVerificationRequestError("SEND_USER_EMAIL_VERIFICATION_REQUEST_FAILED"));
    }
    sendTosConsent(input) {
        const hasValidValues = input && Object.values(input).every(value => !lodash_1.default.isEmpty(value));
        if (hasValidValues)
            return Promise.resolve();
        return Promise.reject(new domain_1.AccountServiceErrors.SendTosConsentRequestError("SEND_TOS_CONSENT_REQUEST_FAILED"));
    }
}
exports.InMemoryAccountService = InMemoryAccountService;
